<div class="row">
	<div class="col-md-2">
		<h1>Main</h1>
	</div>
	<div class="col-md">
		<app-feature-list [featuresList]="featuresList" title="" [shortTermRentalId]="shortTermRentalId"
			featureType="leadFeature" describesType="">
		</app-feature-list>
	</div>
</div>


<div class="row">
	<div class="col-md-2">
		<h1>Living Room</h1>
	</div>
	<div class="col-md">
		<app-feature-list [featuresList]="featuresList" title="Furniture" [shortTermRentalId]="shortTermRentalId"
			featureType="furniture" describesType="LV">
		</app-feature-list><br><br>

		<app-feature-list [featuresList]="featuresList" title="Finishes" [shortTermRentalId]="shortTermRentalId"
			featureType="finish" describesType="LV">
		</app-feature-list><br><br>
	</div>
</div>



<h1>Dining Room</h1>
<app-feature-list [featuresList]="featuresList" title="Furniture" [shortTermRentalId]="shortTermRentalId"
	featureType="furniture" describesType="DN">
</app-feature-list><br><br>

<app-feature-list [featuresList]="featuresList" title="Finishes" [shortTermRentalId]="shortTermRentalId"
	featureType="finish" describesType="DN">
</app-feature-list><br><br>



<h1>Kitchen</h1>
<app-feature-list [featuresList]="featuresList" title="Kitchen" [shortTermRentalId]="shortTermRentalId"
	featureType="kitchen" describesType="KN">
</app-feature-list><br><br>

<app-feature-list [featuresList]="featuresList" title="Furniture" [shortTermRentalId]="shortTermRentalId"
	featureType="furniture" describesType="KN">
</app-feature-list><br><br>

<app-feature-list [featuresList]="featuresList" title="Finishes" [shortTermRentalId]="shortTermRentalId"
	featureType="finish" describesType="KN">
</app-feature-list><br><br>


<h1>Den</h1>
<app-feature-list [featuresList]="featuresList" title="Furniture" [shortTermRentalId]="shortTermRentalId"
	featureType="furniture" describesType="DE">
</app-feature-list><br><br>
<app-feature-list [featuresList]="featuresList" title="Finishes" [shortTermRentalId]="shortTermRentalId"
	featureType="finish" describesType="DE">
</app-feature-list><br><br>



<h1>Family Room</h1>
<app-feature-list [featuresList]="featuresList" title="Games" [shortTermRentalId]="shortTermRentalId"
	featureType="games" describesType="FF">
</app-feature-list>
<br><br>
<app-feature-list [featuresList]="featuresList" title="Furniture" [shortTermRentalId]="shortTermRentalId"
	featureType="furniture" describesType="FF">
</app-feature-list><br><br>
<app-feature-list [featuresList]="featuresList" title="Finishes" [shortTermRentalId]="shortTermRentalId"
	featureType="finish" describesType="FF">
</app-feature-list><br><br>


<h1>Fitness Room</h1>
<app-feature-list [featuresList]="featuresList" title="Fitness" [shortTermRentalId]="shortTermRentalId"
	featureType="fitness" describesType="HL">
</app-feature-list><br><br>
<app-feature-list [featuresList]="featuresList" title="Furniture" [shortTermRentalId]="shortTermRentalId"
	featureType="furniture" describesType="HL">
</app-feature-list><br><br>
<app-feature-list [featuresList]="featuresList" title="Finishes" [shortTermRentalId]="shortTermRentalId"
	featureType="finish" describesType="HL">
</app-feature-list><br><br>


<h1>Entry/Mud Room</h1>
<app-feature-list [featuresList]="featuresList" title="Furniture" [shortTermRentalId]="shortTermRentalId"
	featureType="furniture" describesType="MUD">
</app-feature-list><br><br>
<app-feature-list [featuresList]="featuresList" title="Finishes" [shortTermRentalId]="shortTermRentalId"
	featureType="finish" describesType="MUD">
</app-feature-list><br><br>


<h1>Access</h1>
<app-feature-list [featuresList]="featuresList" title="Property Access" [shortTermRentalId]="shortTermRentalId"
	featureType="access" describesType="">
</app-feature-list>
<br><br>
<app-feature-list [featuresList]="featuresList" title="Handicapped Access" [shortTermRentalId]="shortTermRentalId"
	featureType="ada" describesType="">
</app-feature-list>
<br><br>
<app-feature-list [featuresList]="featuresList" title="Arrival" [shortTermRentalId]="shortTermRentalId"
	featureType="arrival" describesType="">
</app-feature-list>



<h1>Outdoors</h1>
<app-feature-list [featuresList]="featuresList" title="Outdoor" [shortTermRentalId]="shortTermRentalId"
	featureType="outdoor" describesType="">
</app-feature-list><br><br>
<app-feature-list [featuresList]="featuresList" title="Outdoor Feature" [shortTermRentalId]="shortTermRentalId"
	featureType="outdoorFeature" describesType="">
</app-feature-list><br><br>
<app-feature-list [featuresList]="featuresList" title="Outdoor Furniture" [shortTermRentalId]="shortTermRentalId"
	featureType="outdoorFurniture" describesType="">
</app-feature-list>
<br><br>

<h1>View</h1>
<app-feature-list [featuresList]="featuresList" title="View" [shortTermRentalId]="shortTermRentalId" featureType="view"
	describesType="">
</app-feature-list>
<br><br>

<h1>Television</h1>
<app-feature-list [featuresList]="featuresList" title="TV Channels" [shortTermRentalId]="shortTermRentalId"
	featureType="tvChannels" describesType="">
</app-feature-list><br><br>
<app-feature-list [featuresList]="featuresList" title="TV Players" [shortTermRentalId]="shortTermRentalId"
	featureType="tvPlayers" describesType="">
</app-feature-list><br><br>
<app-feature-list [featuresList]="featuresList" title="TV Service" [shortTermRentalId]="shortTermRentalId"
	featureType="tvService" describesType="">
</app-feature-list><br><br>
<app-feature-list [featuresList]="featuresList" title="Tv Type" [shortTermRentalId]="shortTermRentalId"
	featureType="tvType" describesType="">
</app-feature-list><br><br>


<h1>Music System</h1>
<app-feature-list [featuresList]="featuresList" title="Music" [shortTermRentalId]="shortTermRentalId"
	featureType="music" describesType="">
</app-feature-list>
<br><br>


<h1>Telephone</h1>
<app-feature-list [featuresList]="featuresList" title="Phone" [shortTermRentalId]="shortTermRentalId"
	featureType="phone" describesType="">
</app-feature-list>
<br><br>


<h1>Wifi & Computer</h1>
<app-feature-list [featuresList]="featuresList" title="Internet" [shortTermRentalId]="shortTermRentalId"
	featureType="internet" describesType="">
</app-feature-list><br><br>
<app-feature-list [featuresList]="featuresList" title="Computer" [shortTermRentalId]="shortTermRentalId"
	featureType="computer" describesType="">
</app-feature-list><br><br>



<h1>Laundry Room</h1>
<app-feature-list [featuresList]="featuresList" title="Laundry" [shortTermRentalId]="shortTermRentalId"
	featureType="laundry" describesType="">
</app-feature-list><br><br>



<h1>Heating and Cooling</h1>
<app-feature-list [featuresList]="featuresList" title="HVAC" [shortTermRentalId]="shortTermRentalId" featureType="hvac"
	describesType="">
</app-feature-list>
<br><br>
<app-feature-list [featuresList]="featuresList" title="HVAC Type" [shortTermRentalId]="shortTermRentalId"
	featureType="hvacType" describesType="">
</app-feature-list><br><br>



<h1>Linens</h1>
<app-feature-list [featuresList]="featuresList" title="Linens" [shortTermRentalId]="shortTermRentalId"
	featureType="linens" describesType="">
</app-feature-list>
<br><br>


<h1>Housekeeping</h1>
<app-feature-list [featuresList]="featuresList" title="Room Amenities" [shortTermRentalId]="shortTermRentalId"
	featureType="roomAmenity" describesType="">
</app-feature-list><br><br>
<app-feature-list [featuresList]="featuresList" title="Leisure" [shortTermRentalId]="shortTermRentalId"
	featureType="leisure" describesType=""></app-feature-list>
<br><br>
<app-feature-list [featuresList]="featuresList" title="Green" [shortTermRentalId]="shortTermRentalId"
	featureType="green" describesType=""></app-feature-list>
<br><br>
<app-feature-list [featuresList]="featuresList" title="Cleaning" [shortTermRentalId]="shortTermRentalId"
	featureType="cleaning" describesType=""></app-feature-list>
<br><br>
<app-feature-list [featuresList]="featuresList" title="Housekeeping" [shortTermRentalId]="shortTermRentalId"
	featureType="housekeeping" describesType="">
</app-feature-list><br><br>
<app-feature-list [featuresList]="featuresList" title="Comfort" [shortTermRentalId]="shortTermRentalId"
	featureType="comfort" describesType=""></app-feature-list>
<br><br>



<h1>Children</h1>
<app-feature-list [featuresList]="featuresList" title="Child Amenities" [shortTermRentalId]="shortTermRentalId"
	featureType="childAmenity" describesType="">
</app-feature-list><br><br>
<app-feature-list [featuresList]="featuresList" title="Children" [shortTermRentalId]="shortTermRentalId"
	featureType="children" describesType="">
</app-feature-list><br><br>

<h1>Parking</h1>
<app-feature-list [featuresList]="featuresList" title="Parking" [shortTermRentalId]="shortTermRentalId"
	featureType="parking" describesType="">
</app-feature-list><br><br>






<mat-tab label="Overrides">
	<mat-tab-group>
		<mat-tab label="Property">
			<br>
			<app-feature-list [featuresList]="featuresList" title="Property Type"
				[shortTermRentalId]="shortTermRentalId" featureType="propertyType" describesType="">
			</app-feature-list>
			<br><br>
			<app-feature-list [featuresList]="featuresList" title="Location" [shortTermRentalId]="shortTermRentalId"
				featureType="location" describesType="">
			</app-feature-list><br><br>
			<app-feature-list [featuresList]="featuresList" title="Style" [shortTermRentalId]="shortTermRentalId"
				featureType="style" describesType="">
			</app-feature-list><br><br>
			<app-feature-list [featuresList]="featuresList" title="Theme" [shortTermRentalId]="shortTermRentalId"
				featureType="theme" describesType="">
			</app-feature-list><br><br>
			<app-feature-list [featuresList]="featuresList" title="Rules" [shortTermRentalId]="shortTermRentalId"
				featureType="rules" describesType="">
			</app-feature-list><br><br>
			<app-feature-list [featuresList]="featuresList" title="Safety" [shortTermRentalId]="shortTermRentalId"
				featureType="safety" describesType="">
			</app-feature-list><br><br>
			<app-feature-list [featuresList]="featuresList" title="Pets" [shortTermRentalId]="shortTermRentalId"
				featureType="pets" describesType="">
			</app-feature-list>
			<br><br>
			<app-feature-list [featuresList]="featuresList" title="Green Things" [shortTermRentalId]="shortTermRentalId"
				featureType="green" describesType="">
			</app-feature-list><br><br>
			<app-feature-list [featuresList]="featuresList" title="Language" [shortTermRentalId]="shortTermRentalId"
				featureType="language" describesType="">
			</app-feature-list><br><br>
			<app-feature-list [featuresList]="featuresList" title="Currency" [shortTermRentalId]="shortTermRentalId"
				featureType="currency" describesType="">
			</app-feature-list><br><br>
		</mat-tab>

		<mat-tab label="Concierge">
			<app-feature-list [featuresList]="featuresList" title="Onsite In Resort/Complex"
				[shortTermRentalId]="shortTermRentalId" featureType="onsite" describesType="">
			</app-feature-list><br><br>
			<app-feature-list [featuresList]="featuresList" title="Business" [shortTermRentalId]="shortTermRentalId"
				featureType="business" describesType="">
			</app-feature-list><br><br>
			<app-feature-list [featuresList]="featuresList" title="Concierge" [shortTermRentalId]="shortTermRentalId"
				featureType="concierge" describesType="">
			</app-feature-list>
			<br><br>
			<app-feature-list [featuresList]="featuresList" title="Entertainment"
				[shortTermRentalId]="shortTermRentalId" featureType="entertainment" describesType="">
			</app-feature-list><br><br>
			<app-feature-list [featuresList]="featuresList" title="Transport" [shortTermRentalId]="shortTermRentalId"
				featureType="transport" describesType="">
			</app-feature-list>
			<br><br>
			<app-feature-list [featuresList]="featuresList" title="Transport Shuttle"
				[shortTermRentalId]="shortTermRentalId" featureType="transportShuttle" describesType="">
			</app-feature-list><br><br>
		</mat-tab>

		<mat-tab label="Fitness & Spa">
			<app-feature-list [featuresList]="featuresList" title="Fitness" [shortTermRentalId]="shortTermRentalId"
				featureType="fitness" describesType="">
			</app-feature-list><br><br>
			<app-feature-list [featuresList]="featuresList" title="Spa" [shortTermRentalId]="shortTermRentalId"
				featureType="spa" describesType="">
			</app-feature-list>
			<br><br>
		</mat-tab>

		<mat-tab label="Pool & Hotubs">
			<app-feature-list [featuresList]="featuresList" title="Pool Type" [shortTermRentalId]="shortTermRentalId"
				featureType="poolType" describesType="">
			</app-feature-list><br><br>
			<app-feature-list [featuresList]="featuresList" title="Pool" [shortTermRentalId]="shortTermRentalId"
				featureType="pool" describesType="">
			</app-feature-list>
			<br><br>
			<app-feature-list [featuresList]="featuresList" title="Pool Features"
				[shortTermRentalId]="shortTermRentalId" featureType="poolFeatures" describesType="">
			</app-feature-list>
			<br><br>
			<app-feature-list [featuresList]="featuresList" title="Pool Furniture"
				[shortTermRentalId]="shortTermRentalId" featureType="poolFurniture" describesType="">
			</app-feature-list><br><br>
		</mat-tab>

		<mat-tab label="Nearby">
			<app-feature-list [featuresList]="featuresList" title="Nearby" [shortTermRentalId]="shortTermRentalId"
				featureType="nearby" describesType="">
			</app-feature-list><br><br>
			<app-feature-list [featuresList]="featuresList" title="Rentals" [shortTermRentalId]="shortTermRentalId"
				featureType="rentals" describesType="">
			</app-feature-list><br><br>
			<app-feature-list [featuresList]="featuresList" title="Restaurants" [shortTermRentalId]="shortTermRentalId"
				featureType="restaurant" describesType="">
			</app-feature-list>
			<br><br>
			<app-feature-list [featuresList]="featuresList" title="Sports" [shortTermRentalId]="shortTermRentalId"
				featureType="sports" describesType="">
			</app-feature-list>
			<br><br>
			<app-feature-list [featuresList]="featuresList" title="Tours" [shortTermRentalId]="shortTermRentalId"
				featureType="tours" describesType="">
			</app-feature-list><br><br>
		</mat-tab>
	</mat-tab-group>
</mat-tab>


<app-feature-list [featuresList]="featuresList" title="Floorplan" [shortTermRentalId]="shortTermRentalId"
	featureType="floorplan" describesType="">
</app-feature-list>
<br><br>


<app-feature-list [featuresList]="featuresList" title="Lead Bath Features" [shortTermRentalId]="shortTermRentalId"
	featureType="bathroomLeadFeature" describesType="">
</app-feature-list><br><br>
<app-feature-list [featuresList]="featuresList" title="Bathroom Type" [shortTermRentalId]="shortTermRentalId"
	featureType="bathroomType" describesType="">
</app-feature-list><br><br>
<app-feature-list [featuresList]="featuresList" title="Amenities" [shortTermRentalId]="shortTermRentalId"
	featureType="bathroomAmenity" describesType="">
</app-feature-list><br><br>
<app-feature-list [featuresList]="featuresList" title="Linens" [shortTermRentalId]="shortTermRentalId"
	featureType="bathroomLinens" describesType="">
</app-feature-list><br><br>
<app-feature-list [featuresList]="featuresList" title="Features" [shortTermRentalId]="shortTermRentalId"
	featureType="bathroomFeature" describesType="">
</app-feature-list><br><br>
<app-feature-list [featuresList]="featuresList" title="Shower" [shortTermRentalId]="shortTermRentalId"
	featureType="bathroomShower" describesType="">
</app-feature-list><br><br>
<app-feature-list [featuresList]="featuresList" title="Sink" [shortTermRentalId]="shortTermRentalId"
	featureType="bathroomSink" describesType="">
</app-feature-list><br><br>
<app-feature-list [featuresList]="featuresList" title="Toilet" [shortTermRentalId]="shortTermRentalId"
	featureType="bathroomToilet" describesType="">
</app-feature-list><br><br>
<app-feature-list [featuresList]="featuresList" title="Tub" [shortTermRentalId]="shortTermRentalId"
	featureType="bathroomTub" describesType="">
</app-feature-list><br><br>
<app-feature-list [featuresList]="featuresList" title="Access" [shortTermRentalId]="shortTermRentalId"
	featureType="bathroomAccess" describesType="">
</app-feature-list>





<app-feature-list [featuresList]="featuresList" title="Bedroom Type" [shortTermRentalId]="shortTermRentalId"
	featureType="bedroomLeadFeature" describesType="">
</app-feature-list><br><br>
<app-feature-list [featuresList]="featuresList" title="Bedroom Type" [shortTermRentalId]="shortTermRentalId"
	featureType="bedroomType" describesType="">
</app-feature-list><br><br>
<app-feature-list [featuresList]="featuresList" title="Bed Size" [shortTermRentalId]="shortTermRentalId" featureType="bedSize" describesType="">
</app-feature-list>
<br><br>
<app-feature-list [featuresList]="featuresList" title="Linens" [shortTermRentalId]="shortTermRentalId"
	featureType="bedroomLinens" describesType="">
</app-feature-list>
<br><br>
<app-feature-list [featuresList]="featuresList" title="Features" [shortTermRentalId]="shortTermRentalId"
	featureType="bedroomFeature" describesType="">
</app-feature-list><br><br>
<app-feature-list [featuresList]="featuresList" title="Furniture" [shortTermRentalId]="shortTermRentalId"
	featureType="furniture" describesType="">
</app-feature-list><br><br>
<app-feature-list [featuresList]="featuresList" title="Finishes" [shortTermRentalId]="shortTermRentalId"
	featureType="finish" describesType="">
</app-feature-list>
<br><br>
<app-feature-list [featuresList]="featuresList" title="Special Access" [shortTermRentalId]="shortTermRentalId"
	featureType="bedroomAccess" describesType="">
</app-feature-list>